import { render, staticRenderFns } from "./ProvisionBatchTable.vue?vue&type=template&id=d70de762&scoped=true&"
import script from "./ProvisionBatchTable.vue?vue&type=script&lang=js&"
export * from "./ProvisionBatchTable.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionBatchTable.vue?vue&type=style&index=0&id=d70de762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70de762",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70de762')) {
      api.createRecord('d70de762', component.options)
    } else {
      api.reload('d70de762', component.options)
    }
    module.hot.accept("./ProvisionBatchTable.vue?vue&type=template&id=d70de762&scoped=true&", function () {
      api.rerender('d70de762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProvisionBatch/ProvisionBatchTable.vue"
export default component.exports